<template>
    <SmartLinkItemComponent v-if="model" :id="model?.system?.id" :component="!model.system.workflow">
        <div class="basic-content-block" :class="backgroundColor">
            <div class="container" :class="{'pt-0': paddingModifications['pt-0'], 'pb-0': paddingModifications['pb-0']}" data-aos="fade-in">
                <div class="title" v-if="model?.elements?.title?.value">
                    <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                        <h2>{{ model?.elements?.title?.value }}</h2>
                    </SmartLinkStandaloneElement>
                </div>
                <div class="content" v-if="!isEmpty(model?.elements?.content?.value)">
                    <SmartLinkStandaloneElement :codename="type.elements.content.codename">
                        <RichText :value="model.elements.content.value" />
                    </SmartLinkStandaloneElement>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { provide } from 'vue'
import { contentTypes, type BasicContentBlockModel } from '~~/app/models';

provide('isBasicContentBlock', true)

const type = contentTypes.basic_content_block;
const props = defineProps<{ model: BasicContentBlockModel }>();

const paddingModifications = getPaddingModifications(props?.model?.elements?.padding_modifications__padding_modifications);

const backgroundColor = computed(() => {
    switch (firstOrDefault(props?.model?.elements?.background_color?.value)?.codename) {
        case 'white':
            return 'bg-white';
        case 'navy':
            return 'bg-navy';
        default:
            return '';
    }
});
</script>